module.exports = __webpack_public_path__ + "img/mobile-8.97b05754.png";